import { render, staticRenderFns } from "./PosUpdater.vue?vue&type=template&id=3e4e8ffc"
import script from "./PosUpdater.vue?vue&type=script&lang=js"
export * from "./PosUpdater.vue?vue&type=script&lang=js"
import style0 from "./PosUpdater.vue?vue&type=style&index=0&id=3e4e8ffc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports